import React, { useEffect, useState } from 'react';
import "./Row.css";
import axios from "./axios";

function Row({ title, fetchUrl, isLargeRow = false }) {
    const [movies, setMovies] = useState([]);

    const base_url = "https://image.tmdb.org/t/p/original/";

    useEffect(() => {
        async function fetchData() {
            try {
                const request = await axios.get(fetchUrl);
                setMovies(request.data.results);
            } catch (error) {
                console.error("Error fetching movies:", error);
            }
        }
        fetchData();
    }, [fetchUrl]);

    return (
        <div className='row'>
            <h2>{title}</h2>
            <div className='row-posters'>
                {movies.map((movie) => {
                    if ((isLargeRow && movie.poster_path) || (!isLargeRow && movie.backdrop_path)) {
                        return (
                            <img
                                className={`row-poster ${isLargeRow ? "row-poster-large" : ""}`}
                                key={movie.id}
                                src={`${base_url}${isLargeRow ? movie.poster_path : movie.backdrop_path}`}
                                alt={movie.name || movie.title}
                            />
                        );
                    }
                    return null; // Ensure every case returns something
                })}
            </div>
        </div>
    );
}

export default Row;


